import React from 'react';
import PropTypes from 'prop-types';

function TypeSelect({ htmlId, valveTypes, typeId, typePrompt, typeLabel, onChange }) {
  return (
    <div className="control-group">
      <label className="control-label" htmlFor={htmlId}>
        {typeLabel}
      </label>
      <div className="controls">
        <select
          id={htmlId}
          className="span12"
          value={typeId === null ? '' : typeId}
          onChange={(e) => onChange(e.target.value === '' ? null : Number(e.target.value))}>
          <option value="">{typePrompt}</option>
          {valveTypes.map((valveType) => (
            <option key={valveType.id} value={valveType.id}>
              {valveType.type_name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

TypeSelect.propTypes = {
  htmlId: PropTypes.string.isRequired,
  valveTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      type_name: PropTypes.string.isRequired
    })
  ).isRequired,
  typeId: PropTypes.number,
  typePrompt: PropTypes.string.isRequired,
  typeLabel: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

TypeSelect.defaultProps = {
  typeId: null
};

export default TypeSelect;
